import {
  ChangeDetectionStrategy,
  Component,
  inject,
  signal,
} from '@angular/core';
import { Router } from '@angular/router';
import { TreeNode } from 'primeng/api';
import { TreeModule } from 'primeng/tree';
import { ApplicationContextService } from '../../../services/application-context.service';

@Component({
  selector: 'app-site-map',
  imports: [TreeModule],
  standalone: true,
  templateUrl: './site-map.html',
  styleUrl: './site-map.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SiteMap {
  readonly #router = inject(Router);
  readonly #applicationContextService = inject(ApplicationContextService);
  protected readonly treeNodes = signal<TreeNode[]>([]);

  constructor() {
    const routes = this.#router.config;
    const tree = this.mapRoutesToTree(routes);
    this.treeNodes.set(tree);
  }

  private mapRoutesToTree(routes: any[], basePath = ''): TreeNode[] {
    const isOrganizationContext =
      this.#applicationContextService.isOrganizationContext();
    const isAdminContext = this.#applicationContextService.isAdminContext();

    const filterRoute = (route: any): boolean => {
      // Podstawowe filtrowanie
      if (!route.data?.sitemap || route.redirectTo || route.path === '**') {
        return false;
      }

      if (route.data?.onlyForAdmin) {
        return isAdminContext;
      }

      // W kontekście ORGANIZACJI: ukryj onlyForBeneficjent, pokaż onlyForOrganization
      if (isOrganizationContext) {
        return !route.data?.onlyForBeneficjent;
      }

      // W kontekście OSOBISTYM: ukryj onlyForOrganization, pokaż onlyForBeneficjent
      return !route.data?.onlyForOrganization;
    };

    return routes.filter(filterRoute).map((r) => {
      const fullPath = `${basePath}/${r.path}`.replace(/\/+/g, '/');
      const node: TreeNode = {
        label: r.title || r.data?.breadcrumb || r.path || 'Strona',
        key: fullPath,
        data: {
          route: fullPath,
          ignoreSitemapRedirect: r.data?.ignoreSitemapRedirect,
        },
        children: r.children ? this.mapRoutesToTree(r.children, fullPath) : [],
        selectable: true,
      };
      return node;
    });
  }

  public onNodeSelect(event: any): void {
    const route = event.node?.data?.route;
    const ignoreRouteRedirect = event.node?.data?.ignoreSitemapRedirect;
    if (route && !ignoreRouteRedirect) this.#router.navigateByUrl(route);
  }
}
